import { useState } from 'react';
import type { PhieuXuatDieuChuyen } from '@/types/schemas/phieu-xuat-dieu-chuyen.type';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

export const usePhieuXuatDieuChuyenExport = () => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();

  const exportToExcel = async () => {
    setIsExporting(true);
    try {
      const { exportPhieuXuatDieuChuyenExcel, exportPhieuXuatDieuChuyenFromApi } =
        await import('../utils/export-excel');
      if (entity?.slug) {
        await exportPhieuXuatDieuChuyenFromApi({
          entitySlug: entity.slug
        });
        return;
      }

      await exportPhieuXuatDieuChuyenExcel();
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug),
    isExporting
  };
};
